import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import Header from 'containers/PasswordRecoveryPages/Header';
import { translate } from 'helpers/intl';
import messages from 'containers/LoginRecoveryPage/SendLoginPage/messages';
import Form from 'containers/LoginRecoveryPage/SendLoginPage/Form';
import { getEmailSelector, getLoginSelector } from 'store/user/selectors';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

export type SendLoginType = {
  intl: IntlShape;
  email: string;
  onSubmitStep: Function;
  identifiant: string;
};

const SendLoginPage = (props: SendLoginType) => (
  <GaLoadHOC category={EVENT_CATEGORIES.FORGOTTEN_ACCESS_RECOVERY_LOGIN}>
    <>
      <Header
        title={translate({ ...messages.formTitle }, props)}
        subTitle={translate({ ...messages.formSubTitle }, props)}
      />
      <Form
        identifiant={props.identifiant}
        email={props.email}
        onSubmitStep={props.onSubmitStep}
      />
    </>
  </GaLoadHOC>
);

const mapStateToProps = createStructuredSelector<
  any,
  { email: string; identifiant: string }
>({
  email: getEmailSelector,
  identifiant: getLoginSelector,
});

export default connect(mapStateToProps)(injectIntl(SendLoginPage));
